import Vue from 'vue';
// import moment from 'moment/src/moment';
import moment from 'moment';
// import { VListItemSubtitle } from 'vuetify/lib';

Vue.filter('capitalize', (value) => {
  if (!value) return '';
  const vl = value.toString();
  return vl.charAt(0).toUpperCase() + vl.slice(1);
});

Vue.filter('uppercase', (value) => {
  if (!value) return '';
  return value.toString().toUpperCase();
});

Vue.filter('lowercase', (value) => {
  if (!value) return '';
  return value.toString().toLowerCase();
});

Vue.filter('currency', (value) => {
  if (!value) return '';
  return `R$ ${parseFloat(value).toFixed(2)}`;
});

Vue.filter('ISOToDate', (value) => {
  if (!value) return '';
  return moment.utc(value).format('DD/MM/YYYY');
});

Vue.filter('date', (value) => {
  if (!value) return '';
  return moment.utc(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
});

Vue.filter('dateToLongDate', (value) => {
  if (!value) return '';
  return moment.utc(value, 'YYYY-MM-DD', 'pt-BR').format('dddd, DD [de] MMMM');
});

Vue.filter('timeToHM', (value) => {
  if (!value) return '';
  return moment(value, 'HH:mm:SS').format('HH:mm');
});

Vue.filter('km', (value) => {
  if (!value) return '';
  return `${value.toFixed(2)} km`;
});

// Vue.filter('realToCents', (value) => {
//   if (!value) return '';
//   const parts = `${value}`.split(',');
//   const reais = parts[0];
//   const cents = parts[1] || 0;
//   return (Number(reais) * 100) + Number(cents);
// });

// Vue.filter('centsToReal', (value) => {
//   if (!value) return '';
//   return 'TODO';
// });
